import { getEventEmitter } from '@process-advisor/process-miner/processMiner/processMiner';
import { Event } from '@process-advisor/process-miner/api/events';


export async function closeProgressModal () {
    getEventEmitter().emit(Event.closeProgressModal);
};
